module.exports = __webpack_public_path__ + "img/number_3.310a34f7.png";